import { logWrapper } from '../../utils';

export default {
  obsoleteDocumentModalController: [
    'runtimeConstant',
    '$scope',
    '$uibModalInstance',
    'revisionListService',
    '$uibModal',
    '$filter',
    '$window',
    'EDocumentStatus',
    'webApiSettings',
    function (runtimeConstant, $scope, $uibModalInstance, revisionListService, uibModal, $filter, $window, EDocumentStatus, webApiSettings) {
      'use strict';

      $scope.messageTitle = $filter('translate')('OBSOLETE');
      $scope.messageCancel = $scope.messageCancel || 'CANCEL';

      function parent_cancelButton() {
        $scope.modalBecomeObsolete.close();
      }

      function obsoleteModal() {
        if (webApiSettings.detailsCompany === 'abase') {
          var ids = $scope.docs.map(function(doc) {
            return doc.id;
          });

          revisionListService
            .becomeObsoleteIds(ids)
            .then(() => {
              for (var i = 0, len = $scope.docs.length; i < len; i++) {
                var rev = $scope.docs[i];

                rev.idStatus = 4;
                rev.updatePermissions();
              }

              if ($scope.docs.some((d) => d.hasLinkedDocuments)) {
                $scope.$broadcast('reloadDocuments');
              }
              $scope.modalBecomeObsolete.close();
              $window.location.reload();
            })
            .catch(() => {
              $scope.modalBecomeObsolete.close();

              $scope.modalError = uibModal.open({
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'obsoleteDocumentModalController',
                size: 'small',
                windowClass: 'modal-remove',
                resolve: {
                  revisions: () => $scope.docs,
                },
              });
            });
        } else {
          var revisions = $scope.docs
            .map((d) => ({
              id: d.id,
              revisionNumber: d.revisionNumber,
              idFolder: d.idFolder,
            }));

          revisionListService
            .becomeObsolete(revisions)
            .then(() => {
              for (var i = 0, len = $scope.docs.length; i < len; i++) {
                var rev = $scope.docs[i];

                rev.idStatus = 4;
                rev.updatePermissions();
              }

              if ($scope.docs.some((d) => d.hasLinkedDocuments)) {
                $scope.$broadcast('reloadDocuments');
              }
              $scope.modalBecomeObsolete.close();
              $window.location.reload();
            })
            .catch(() => {
              $scope.modalBecomeObsolete.close();

              $scope.modalError = uibModal.open({
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'obsoleteDocumentModalController',
                size: 'small',
                windowClass: 'modal-remove',
                resolve: {
                  revisions: () => $scope.docs,
                },
              });
            });
        }
      }

      function cancelButton() {
        $uibModalInstance.dismiss('cancel');
      }

      function run() {
        try {
					$scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.obsoleteModal = logWrapper(
            obsoleteModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
